module.exports = "/_next/static/images/buyers_1-ee5392bc3fdfe5cb832e11bf786c144e.png";